export default __webpack_public_path__ + "static/media/Tablet-Checklist-SOP-600.b96fa907.png";